import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
const useStyles = makeStyles((theme) => ({
    description: {
        color: theme.palette.grey['500'],
        fontSize: 'smaller'
    }
}));
export const RenderOption = () => {
    const classes = useStyles();
    return (option) => (React.createElement("div", { "data-location-code": option.code },
        React.createElement("div", null, option.name),
        option.description ?
            React.createElement("div", { className: classes.description }, option.description)
            : null));
};
//# sourceMappingURL=RenderOption.js.map